export const wordsCollection = {
  'kilometre': ['километр', 'километра', 'километров'],
  'metre': ['метр', 'метра', 'метров'],
  'second': ['секунда', 'секунды', 'секунд'],
  'kilogram': ['килограмм', 'килограмма', 'килограммов'],
  'ampere': ['ампер', 'ампера', 'ампер'],
  'kelvin': ['кельвин', 'кельвина', 'кельвинов'],
  'candela': ['кандел', 'кандел', 'кандел'],
  'mole': ['моль', 'моль', 'моль'],
  'centimetre': ['сантиметр', 'сантиметра', 'сантиметров'],
  'millimetre': ['миллиметр', 'миллиметра', 'миллиметров'],
  'micrometre': ['микрометр', 'микрометра', 'микрометров'],
  'nanometre': ['нанометр', 'нанометра', 'нанометров'],
  'square-kilometre': ['квадратный километр', 'квадратных километра', 'квадратных километров'],
  'hectare': ['гектар', 'гектара', 'гектар'],
  'are': ['сотка', 'сотки', 'соток'],
  'square-centimetre': ['квадратный сантиметр', 'квадратных сантиметра', 'квадратных сантиметров'],
  'cubic-metre': ['кубический метр', 'кубических метра', 'кубических метров'],
  'cubic-centimetre': ['кубический сантиметр', 'кубических сантиметр', 'кубических сантиметров'],
  'litre': ['литр', 'литра', 'литров'],
  'millilitre': ['миллилитр', 'миллилитра', 'миллилитров'],
  'metric-ton': ['тонна', 'тонны', 'тонн'],
  'gram': ['грамм', 'грамма', 'граммов'],
  'milligram': ['миллиграмм', 'миллиграмма', 'миллиграммов'],
  'microgram': ['микрограмм', 'микрограмма', 'микрограммов'],
  'hertz': ['герц', 'герца', 'герц'],
  'newton': ['ньютон', 'ньютона', 'ньютонов'],
  'joule': ['джоуль', 'джоуля', 'джоулей'],
  'pascal': ['паскаль', 'паскаль', 'паскаль'],
  'watt': ['ватт', 'ватта', 'ватт'],
  'volt': ['вольт', 'вольта', 'вольт'],
  'farad': ['фарад', 'фарад', 'фарад'],
  'ohm': ['ом', 'ом', 'ом'],
  'lumen': ['люмен', 'люмен', 'люмен'],
}

export const ruTableDictionary = {
  'Undo': 'Отменить',
  'Redo': 'Повторить',
  'Cut': 'Вырезать',
  'Copy': 'Копировать',
  'Paste': 'Вставить',
  'Save as': 'Сохранить как',
  'Search': 'Поиск',
  'About': 'О программе',
  'Are you sure?': 'Вы уверены?',
  'This action can not be undone, are you sure?': 'Действие необратимо, вы уверены?',
  'Add new row': 'Добавить строку',
  'Add new column': 'Добавить колонку',
  'Insert a new row': 'Вставить строку',
  'Insert a new row before': '+ Строка выше',
  'Insert a new row after': '+ Строка ниже',
  'Insert a new column': 'Вставить колонку',
  'Insert a new column before': '+ Столбец слева',
  'Insert a new column after': '+ Столбец справа',
  'Insert row above': 'Вставить строку выше',
  'Insert row below': 'Вставить строку ниже',
  'Insert column left': 'Вставить колонку слева',
  'Insert column right': 'Вставить колонку справа',
  'Delete selected rows': 'Удалить',
  'Delete selected row': 'Удалить',
  'Delete selected columns': 'Удалить',
  'Delete selected column': 'Удалить',
  'Hide row': 'Скрыть строку',
  'Show row': 'Показать строку',
  'Hide column': 'Скрыть колонку',
  'Show column': 'Показать колонку',
  'Rename this column': 'Переименовать колонку',
  'Resize column': 'Изменить ширину колонки',
  'Rename this row': 'Переименовать строку',
  'Resize row': 'Изменить высоту строки',
  'Move row up': 'Переместить строку вверх',
  'Move row down': 'Переместить строку вниз',
  'Order ascending': 'Сортировать по возрастанию',
  'Order descending': 'Сортировать по убыванию',
  'Clear contents': 'Очистить содержимое',
  'Merge cells': 'Объединить ячейки',
  'Unmerge cells': 'Разъединить ячейки',
  'Text align': 'Выравнивание текста',
  'Left': 'Влево',
  'Center': 'По центру',
  'Right': 'Вправо',
  'Wrap text': 'Перенос текста',
  'No wrap': 'Без переноса',
  'Rename this worksheet': 'Переименовать лист',
  'Delete this worksheet': 'Удалить лист',
  'New worksheet': 'Новый лист',
  'Add comments': 'Добавить комментарии',
}

export const alphabet = [
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
]
